import React from "react";
import { useNavigate } from "react-router-dom";
import FullPageWithHeaderAndProgress from "pages/container/FullPageWithHeaderAndProgress";
import { YoutubeChannelDetail } from "../part/acquisition/YoutubeChannelDetail";

export default function YoutubeChannel() {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(`/onboarding_new/acquisition/1`);
  };

  return (
    <FullPageWithHeaderAndProgress
      headerTitle={undefined}
      hideProgress={true}
      body={<YoutubeChannelDetail />}
      onBack={handleBack}
    />
  );
}
